<div class="confirm-dialog">
<div class="modal-content">
    <div class="content-row">
    <div class="confirm-title" [ngClass]="{'dd-confirm-title-lexus': dealerDetails?.isLexus}">OPTIONAL - Enter comments/notes. If none, CONFIRM</div>
    <textarea maxlength="200" rows="5" cols="55"  [(ngModel)]="comments" id="vspec-form-comment" class="text-area"></textarea>
    <div class="warning-message">{{200-comments.length}} characters remaining</div>
    </div>
</div>
<div class="modal-footer">
    <div class="action-buttons">
    <button class="dd-btn-download secondary"  (click)="onCancel()" [ngClass]="{'secondary-lexus': dealerDetails?.isLexus}">Cancel</button>
    <button class="dd-btn-download primary" (click)="onConfirm()" [ngClass]="{'primary-lexus': dealerDetails?.isLexus}">Confirm</button>
    </div>
</div>
</div>